<template>
  <TheLoader :active="true" v-if="loading"/>
  <div class="content-container flex-row" v-else>
    <!-- Filter -->
    <a href="javascript:;" @click="toggleFilterSidebar()" class="button action toggle-sidebar-button fixed glyph hide-for-xxxlarge" data-sidebar-id="subnav" v-if="items.length > 0">
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-filter"></use></svg>
      Filtrering
    </a>

    <div class="sidebar left fixed subnav responsive xxlarge-down table-filter-nav" id="subnav" v-if="items.length > 0">
      <div class="fixed-container">
        <ul>
          <li>
            <a href="javascript:;" :class="{'active': !queryParams.filter}" @click="changeFilter(null)">Alle</a>
            <a href="javascript:;" :class="{'active': queryParams.filter === 'S'}" @click="changeFilter('S')">Kjøperbilag</a>
            <a href="javascript:;" :class="{'active': queryParams.filter === 'K'}" @click="changeFilter('K')">Oppgjørsbilag</a>
          </li>
        </ul>
      </div>
    </div>

    <section id="kunde-scrollable-container" class="content white">
      <TheLoader :active="updating" style="opacity:0.5"/>
      <TheEmptyList v-if="items.length < 1" :title="'Ingen bilag'" :large="true" :icon="'glyph-medium-contract'"/>

      <table v-if="items.length > 0" class="large fixed visible sortable evenodd contracts table-filter">
        <thead>
          <tr>
            <th v-for="(heading, index) in headings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === queryParams.sort ? sortClass : '']" @click="changeSorting(heading.sortKey)">
              {{heading.name}}
              <span id="sorttable_sortrevind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'desc'">&nbsp;</span>
              <span id="sorttable_sortfwdind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'asc'">&nbsp;</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in items">
            <tr v-bind:key="'main-' + item.Bilagsid">
              <td class="all" :class="{'has-tooltip': getObjektInfo(item)}" :data-tooltip="getObjektInfo(item)">
                <span class="icon-container">
                  <span class="avatar small icon">
                    <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-contract"></use></svg>
                  </span>
                  <a href="javascript:;" class="primary-title">{{item.Bilagsid}}</a>
                </span>
              </td>
              <td :class="{'has-tooltip': getObjektInfo(item)}" :data-tooltip="getObjektInfo(item)">{{ getFakturanr(item) }}</td>
              <td>{{item.Bilagsart === 'K' ? 'Oppgjør' : 'Kjøper'}}</td>
              <td class="show-for-large">{{item.Bilagstype == 'F' ? 'Faktura' : 'Kreditnota'}}</td>
              <td class="show-for-medium">{{item.Kontraktnr}}</td>
              <td class="show-for-medium">{{item.Auksjon}}</td>
              <td class="align-right show-for-medium"><span class="opacity-60">{{item.Dato | avantidate}}</span></td>
              <td class="align-right">
                <a v-if="isManagement && item.Bilagstype != 'K' && item.Bilagsart != 'K' && item.bilagsnr_kreditnota == null" href="javascript:;" style="margin-bottom: 10px;" class="button action" @click="showCredit(item)">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-transfer"></use></svg>
                  <span>Krediter asd</span>
                </a>

                <span style="margin-left: 1rem; margin-right: 0.5rem;" class="button-container has-popover" :class="{'popover-active': pdfPopoverActive === item.Bilagsid}">
                  <span class="button action glyph glyph-only" @click="togglePdfPopover(item.Bilagsid)">
                    <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg>
                  </span>
                  <span class="popover align-x-right align-y-bottom medium">
                    <ul>
                      <li><a href="javascript:;" @click="showBilagsPdf(item)"><span>Vis strekkode</span></a></li>
                      <li><a href="javascript:;" @click="showBilagsEmailPdf(item)"><span>Skriv ut / send e-post</span></a></li>
                    </ul>
                  </span>
                </span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <div class="pagination-container"  v-if="pageCount > 1" style="margin-top: 3rem;">
        <paginate v-model="currentPage"
          :page-count="pageCount"
          :page-range="11"
          :click-handler="changePage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import accounting from 'accounting-js'

export default {
  name: 'KundeCardShowTabFaktura',
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      headings: [
        {name: 'Bilagsid', sortKey: 'Bilagsid', class: ''},
        {name: 'Fakturanr', sortKey: 'Bilagsnr', class: ''},
        {name: 'Bilagsart', sortKey: 'Bilagsart', class: ''},
        {name: 'Bilagstype', sortKey: 'Bilagstype', class: 'show-for-large'},
        {name: 'Kontraktnr', sortKey: 'Kontraktnr', class: 'show-for-medium'},
        {name: 'Auksjon', sortKey: 'Auksjon', class: 'show-for-medium'},
        {name: 'Dato', sortKey: 'Dato', class: 'align-right show-for-medium'},
        {name: '', sortKey: '', class: ''}
      ],
      pdfPopoverActive: null
    }
  },
  created () {
    // Note: The fetch of items is done in KundeCard.
    this.currentPage = this.queryParams.page || 1

    const vm = this

    window.jQuery(document).mouseup(function (e) {
      var container = window.jQuery('.has-popover')

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        vm.pdfPopoverActive = null
      }
    })
  },
  updated () {
    setTimeout(function () {
      // Tooltip
      if (window.jQuery('.has-tooltip') && window.jQuery('.has-tooltip').length > 0) {
        let $tooltip = window.jQuery('.tooltip')

        window.jQuery('.has-tooltip').unbind('hover')
        window.jQuery('.has-tooltip').hover(function () {
          let $tooltipData = window.jQuery(this).data('tooltip')
          let $tooltipHeight = $tooltip.height() + 60
          let $scrollTop = window.jQuery(window).scrollTop()
          $tooltip.html($tooltipData)

          // show tooltip if not already activeted
          if (!$tooltip.hasClass('active')) {
            $tooltip.addClass('active')

            window.jQuery(document).bind('mousemove', function (e) {
              $tooltip.css({
                left: e.pageX,
                top: e.pageY
              })

              if ((e.pageY - $scrollTop) + $tooltipHeight < window.innerHeight) {
              // if ($offsetBottom > $tooltipHeight) {
                $tooltip.css({
                  left: e.pageX - 125,
                  top: e.pageY - $scrollTop + 30
                })
              } else {
                // offset the tooltip if to close to bottom
                $tooltip.css({
                  left: e.pageX - 125,
                  top: e.pageY - $scrollTop - $tooltipHeight
                })
              }
            })
          }
        },
        // hide the tooltip on blur
        function () {
          $tooltip.removeClass('active')

          window.jQuery(document).unbind('mousemove', function (e) {})
        })
      }
    })
  },
  mounted () {
    setTimeout(function () {
      // Tooltip
      if (window.jQuery('.has-tooltip') && window.jQuery('.has-tooltip').length > 0) {
        let $tooltip = window.jQuery('.tooltip')

        window.jQuery('.has-tooltip').unbind('hover')
        window.jQuery('.has-tooltip').hover(function () {
          let $tooltipData = window.jQuery(this).data('tooltip')
          let $tooltipHeight = $tooltip.height() + 60
          let $scrollTop = window.jQuery(window).scrollTop()

          $tooltip.html($tooltipData)

          // show tooltip if not already activeted
          if (!$tooltip.hasClass('active')) {
            $tooltip.addClass('active')

            window.jQuery(document).bind('mousemove', function (e) {
              $tooltip.css({
                left: e.pageX,
                top: e.pageY
              })

              if ((e.pageY - $scrollTop) + $tooltipHeight < window.innerHeight) {
              // if ($offsetBottom > $tooltipHeight) {
                $tooltip.css({
                  left: e.pageX - 125,
                  top: e.pageY - $scrollTop + 30,
                  'max-width': '800px'
                })
              } else {
                // offset the tooltip if to close to bottom
                $tooltip.css({
                  left: e.pageX - 125,
                  top: e.pageY - $scrollTop - $tooltipHeight,
                  'max-width': '800px'
                })
              }
            })
          }
        },
        // hide the tooltip on blur
        function () {
          $tooltip.removeClass('active')

          window.jQuery(document).unbind('mousemove', function (e) {})
        })
      }
    })
  },
  computed: {
    ...mapGetters('kundebilag', [
      'items',
      'groups',
      'pageCount',
      'queryParams',
      'loading',
      'updating'
    ]),
    sortClass: function () {
      return 'sorttable_sorted' + (this.queryParams.direction !== 'asc' ? '_reverse' : '')
    },
    isAccounting: function () {
      return this.hasAccess('accounting')
    },
    isAdmin: function () {
      return this.hasAccess('admin')
    },
    isManagement: function () {
      return this.hasAccess('management')
    }
  },
  methods: {
    getFakturanr: function (item) {
      if (item.twentyfourseven_invoice_id && item.Dato > '2019-12-31') {
        return item.twentyfourseven_invoice_id
      }

      return item.Bilagsnr
    },
    getObjektInfo: function (item) {
      if (!item.bilagslinje) {
        return null
      }

      const retval = []

      let total = 0
      item.bilagslinje.forEach(element => {
        if (element.Varetype === 'O') {
          retval.push(this._.trimEnd(element.Beskrivelse, ' .,!') + ', ' + element.Varenr + ', ' + accounting.formatNumber(element.Beloptotal, {precision: 2, thousand: ''}) + 'kr')
        }

        total += parseFloat(element.Beloptotal)
      })

      if (retval.length > 0) {
        retval.push('')
        retval.push('Total: ' + accounting.formatNumber(total, {precision: 2, thousand: ''}) + 'kr')

        return retval.join('<br>')
      }

      return null

      // const objektLines = item.bilagslinje.filter(x => x.Varetype === 'O')

      // // linje->Beloptotal = Tilslag where Varetype = 'O'
      // // alla linje.Beloptotal = Totalprisen

      // if (objektLines.length > 0) {
      //   retval.push('Bilagsid: ' + item.Bilagsid)
      //   retval.push('')

      //   objektLines.forEach(i => {
      //     retval.push(i.Beskrivelse + ': ' + i.Varenr)
      //   })
      //   console.log('ITEM')
      //   console.log(item)

      //   return retval.join('<br>')
      // }
      // return null
    },
    changePage: function (page) {
      var vm = this
      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        // Update a copy of the query params, to send to our store
        let copiedParams = vm._.clone(vm.queryParams)
        vm.currentPage = page
        copiedParams.page = vm.currentPage

        vm.$store.dispatch('kundebilag/reload', {
          kundenr: vm.kunde.Kundenr,
          queryParams: copiedParams
        })
      })
    },
    changeSorting: function (sortKey) {
      if (!sortKey) {
        return
      }

      // Update a copy of the query params, to send to our store
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = 1
      copiedParams.page = this.currentPage

      if (copiedParams.sort === sortKey) {
        copiedParams.direction = copiedParams.direction === 'asc' ? 'desc' : 'asc'
      } else {
        copiedParams.direction = 'asc'
      }

      copiedParams.sort = sortKey

      this.$store.dispatch('kundebilag/reload', {
        kundenr: this.kunde.Kundenr,
        queryParams: copiedParams
      })
    },
    changeFilter: function (code) {
      var vm = this

      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        // Update a copy of the query params, to send to our store
        let copiedParams = vm._.clone(vm.queryParams)
        vm.currentPage = 1
        copiedParams.page = vm.currentPage
        copiedParams.filter = code

        vm.$store.dispatch('kundebilag/reload', {
          kundenr: vm.kunde.Kundenr,
          queryParams: copiedParams
        })
      })
    },
    toggleFilterSidebar: function () {
      this.$helpers.toggleSidebar('subnav')
    },
    togglePdfPopover: function (id) {
      if (!this.pdfPopoverActive || this.pdfPopoverActive !== id) {
        this.pdfPopoverActive = id
      } else {
        this.pdfPopoverActive = null
      }
    },
    showCredit: function (item) {
      this.pdfPopoverActive = null
      this.openModal('kreditering-bilag-modal', { kunde: this.kunde, bilag: item, internalWindow: true })
    },
    showBilagsPdf: function (item) {
      this.pdfPopoverActive = null
      this.openModal('bilag-pdf-modal', { bilag: item, internalWindow: true }, 'split')
    },
    showBilagsEmailPdf: function (item) {
      this.pdfPopoverActive = null
      this.openModal('bilag-email-pdf-modal', { query: item, internalWindow: true }, 'split')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardShowTabFaktura.vue